// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2guQD","colMin":"styles_colMin__31b14"};